import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';
import { MobileFeedWallFiltersPopup } from './MobileFeedWallFiltersPopup';
import { FeedFilters } from './FeedFilters';
import { useFeedWallParams } from 'hooks/useFeedWallParams';

export const FeedWallHeader = () => {
  const { handleReset } = useFeedWallParams();

  return (
    <div css={headerContainerStyles}>
      <div css={titleRowStyles}>
        <h2 css={titleStyles}>Your community feed</h2>
        <button type="button" css={resetButtonStyles} onClick={handleReset}>
          Reset
        </button>
        <div css={mobileOnlyStyles}>
          <MobileFeedWallFiltersPopup />
        </div>
      </div>
      <div css={desktopOnlyStyles}>
        <FeedFilters />
      </div>
    </div>
  );
};

const headerContainerStyles = css({
  [MOBILE.MEDIA_QUERY]: {
    marginBottom: token('space.200', '24px'),
  },
});

const desktopOnlyStyles = css({
  display: 'flex',
  alignItems: 'flex-end',
  gap: token('space.250', '32px'),
  flexWrap: 'wrap',
  [MOBILE.MEDIA_QUERY]: {
    display: 'none',
  },
});

const mobileOnlyStyles = css({
  display: 'none',
  [MOBILE.MEDIA_QUERY]: {
    display: 'block',
  },
});

const titleRowStyles = css({
  display: 'flex',
  alignItems: 'center',
  marginBottom: token('space.200', '24px'),
  gap: token('space.150', '16px'),
  [MOBILE.MEDIA_QUERY]: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: token('space.050', '4px'),
    marginBottom: token('space.100', '12px'),
  },
});

const titleStyles = css({
  fontWeight: token('font.weight.bold', '700'),
  fontSize: '24px',
  margin: 0,
  color: token('color.text', '#253858'),
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '18px',
  },
});

const resetButtonStyles = css({
  marginLeft: token('space.150', '16px'),
  fontSize: '14px',
  color: token('color.link', '#0052CC'),
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  textDecoration: 'none',
  fontWeight: token('font.weight.medium', '400'),
  lineHeight: 1.5,
  ':hover': {
    textDecoration: 'underline',
    color: token('color.link.pressed', '#0747A6'),
  },
  [MOBILE.MEDIA_QUERY]: {
    display: 'none',
  },
});
